import { api } from "@/api/client";
import type { PagedResult } from "@/types/api";

/**
 * Activity Feed Aggregator v1.0 (PR 4) — typed wire shapes for the
 * cross-module Activity tab (Layout Standard §4.8). The aggregator fans
 * out to existing audit tables in Tasks / Messaging / Communications /
 * Notes / per-module logs and returns one merged feed.
 */
export const ActivityEventSourceValues = {
  Tasks: 0,
  Messaging: 1,
  Communications: 2,
  Notes: 3,
  Documents: 4,
  Module: 99,
} as const;

export type ActivityEventSource =
  (typeof ActivityEventSourceValues)[keyof typeof ActivityEventSourceValues];

export interface ActivityEvent {
  id: string;
  occurredAt: string;
  source: ActivityEventSource;
  actorDisplayName: string;
  actorId: string | null;
  headline: string;
  subline: string | null;
  icon: string | null;
  clickThroughUrl: string | null;
  payload: unknown;
}

export interface ActivityFeedQuery {
  since?: string;
  skip?: number;
  take?: number;
}

export const activityApi = {
  listByOwner: (
    ownerType: string,
    ownerId: string,
    query: ActivityFeedQuery = {},
  ) =>
    api.get<PagedResult<ActivityEvent>>(
      `activity/by-owner/${encodeURIComponent(ownerType)}/${encodeURIComponent(ownerId)}`,
      query,
    ),

  recentCount: (ownerType: string, ownerId: string, windowDays = 7) =>
    api.get<number>(
      `activity/by-owner/${encodeURIComponent(ownerType)}/${encodeURIComponent(ownerId)}/recent-count`,
      { windowDays },
    ),
};
